import React from 'react';
import _ from '@dh-fe/translate';
import { useTheme } from 'contexts/ThemeContext';
import useMediaQuery from 'hooks/useMediaQuery';
import { Breakpoints } from 'configs/breakpoints';
import Icon, { IconList } from 'components/Icon';
import Image from 'components/Image/Image';
import classnames from 'classnames';
import style from './SafeSection.module.scss';
import { getContent } from './SafeSectionContent';

const SafeSection = () => {
    const { bg: bgDesktop, bgMobile } = getContent();
    const { theme } = useTheme();
    const isMobile = useMediaQuery(Breakpoints.VERY_SMALL);
    const bg = isMobile ? bgMobile : bgDesktop;

    return (
        <section className={classnames(style[theme], style.safeSection)}>
            <Image unCompressed={bg} webp={bg} alt="background image" />
            <div className={style.container}>
                <h1>{_`Safe and Secure`}</h1>
                <div className={style.content}>
                    <div className={style.item}>
                        <Icon icon={IconList.payoutSolid} size="5.6rem" />
                        <div>{_`Immediate Payout`}</div>
                    </div>
                    <div className={style.item}>
                        <Icon icon={IconList.supportSolid} size="5.6rem" />
                        <div>{_`24/7 Live Support`}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SafeSection;
